import { render, staticRenderFns } from "./TransacaoProgramada.vue?vue&type=template&id=952df454&scoped=true"
import script from "./TransacaoProgramada.vue?vue&type=script&lang=js"
export * from "./TransacaoProgramada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952df454",
  null
  
)

export default component.exports